import i18n from '@/api/i18n/i18n';

export const OPTIONS = [
  {
    id: 0,
    name: i18n.t('settings.diagnostics.allAgents'),
  },
  {
    id: 1,
    name: i18n.t('settings.diagnostics.agentsWithProblems'),
  },
];

export const TREE_DATA = {
  columns: [
    {
      field: 'id',
      title: 'ID',
      width: 50,
      align: 'left',
      titleAlign: 'left',
    },
    {
      field: 'username',
      title: i18n.t('settings.diagnostics.columns.user'),
      width: 200,
      align: 'left',
      titleAlign: 'left',
      sort: 2,
      sorted: true,
      flex: 1,
    },
    {
      field: 'compName',
      title: i18n.t('settings.diagnostics.columns.compName'),
      width: 200,
      align: 'left',
      titleAlign: 'left',
      sort: 0,
      sorted: true,
      flex: 1,
    },
    {
      field: 'departName',
      title: i18n.t('settings.diagnostics.columns.placement'),
      width: 200,
      align: 'left',
      titleAlign: 'left',
      sort: 0,
      sorted: true,
      flex: 1,
    },
    {
      field: 'error',
      title: i18n.t('settings.diagnostics.columns.error'),
      width: 200,
      align: 'left',
      titleAlign: 'left',
      sort: 0,
      sorted: true,
      flex: 2,
    },
  ],
  lists: [],
};
